export default __webpack_public_path__ + "static/media/ApiSteps.cf758730.pdf";